module.exports = __webpack_public_path__ + "assets1779866876160/img/error-500.a371eabc.svg";